import 'ol/ol.css';
import VectorSource from 'ol/source/Vector';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import FeatureDrawer from "../helpers/FeatureDrawer";
import MapElement from './MapElement';


export default class MapChangesChild extends MapElement {
    constructor(map, id, mapElementSettings, parent, projection) {
        super(map, id, mapElementSettings, parent)

        this.projection = projection;
        this.changes;
    }

    drawLayer(data) {
        if (data != null) {
            var featureDrawer = new FeatureDrawer(this.projection, this.mapModel.projection);

            var features = [];
            this.changes = 0;
            data.changes.forEach((change) => {
                if (change.start.x != 0 && change.start.y != 0) {

                    var coordinates = { x: change.start.x, y: change.start.y }

                    var feature = featureDrawer.drawPoint(coordinates)
                    feature.set('handle', change.handle);
                    feature.set('layer', change.layer);
                    features.push(feature);
                    this.changes++;
                }
            });

            var source = new VectorSource();
            source.addFeatures(features);

            var color = this.id == "CONNECTEDLINES" ? [80, 204, 0] : [255, 0, 0];
            var opacity = this.id == "CONNECTEDLINES" ? 0.4 : 0.2;

            this.layer = new WebGLPointsLayer({
                parentId: this.parent.id,
                source: source,
                style: {
                    variables: {
                        connected: Number(this.id == "CONNECTEDLINES"),
                    },
                    "circle-fill-color": 
                    [
                        "case",
                        ["==", ["var", "connected"], 1],
                        "#50CC00",
                        "#FF0000"
                    ],
                    "circle-opacity":
                    [
                        "case",
                        ["==", ["var", "connected"], 1],
                        0.6,
                        0.4
                    ],
                    "circle-radius": [
                        "interpolate",
                        [
                          "exponential",
                          2
                        ],
                        [
                          "zoom"
                        ],
                        5,
                        1.5,
                        15,
                        10
                      ],
                }
            });

            if (this.parent) {
                this.parent.layer.getLayers().push(this.layer);
            }
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    // getLayers() {
    //     if (!this.mapElementSettings.interactable || !this.layer) {
    //         return null;
    //     }

    //     return { id: this.id, name: this.id, amountChanges: this.changes, show: this.show.bind(this), hide: this.hide.bind(this), children: [] };

    // }

    getLayers() {
        var layerObject = super.getLayers()
        layerObject.amountChanges = this.changes;

        return layerObject;
    }
}